import { jsxs as l, jsx as h } from "react/jsx-runtime";
const r = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "m6.029 51.273 14.453 6.712c.005.002.011-.001.011-.007v-.923h.003v-15.96c0-.004.003-.008.008-.008h3.767c9.837 0 17.889-8.016 17.716-17.851-.168-9.526-7.969-17.225-17.535-17.225H6.036s-.008.003-.008.008v45.253l.001.001ZM24.45 37.015h-8.019s-.008.003-.008.008v13.543c0 .006-.006.009-.011.007l-6.309-3.034s-.004-.004-.004-.007l.058-37.442s.003-.008.008-.008h14.126c7.558 0 13.758 6.153 13.624 13.709-.13 7.315-6.12 13.225-13.465 13.225v-.001Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M24.465 16.376H16.38v14.422h8.085a7.218 7.218 0 0 0 7.211-7.211 7.218 7.218 0 0 0-7.211-7.211Zm0 10.351h-4.013v-6.279h4.013a3.144 3.144 0 0 1 3.14 3.14 3.143 3.143 0 0 1-3.14 3.139ZM46.857 35.761c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.23c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M47.736 49.856h-2.133c.732-.489 1.009-1.27 1.009-2.035 0-.098 0-.196-.016-.293h2.295v-1.791h-2.865c-.163-.424-.277-.798-.277-1.286 0-.863.602-1.27 1.254-1.27.846 0 1.303.569 1.319 1.562l2.133-.569c-.082-1.335-.977-3.012-3.483-3.012-2.279 0-3.581 1.611-3.581 3.207 0 .537.081.977.212 1.367h-.928v1.791h1.579c.033.179.065.358.065.537 0 .96-.667 1.628-1.693 1.986v1.921h5.437c1.807 0 3.028-1.352 3.028-3.19l-2.149-.13c0 .732-.52 1.205-1.205 1.205h-.001Z"
        }
      )
    ]
  }
);
export {
  r as TopUpInPaypointShop
};
